import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { ResolvedVideo } from '../ResolvedVideo';

const VideoEmbedComponent: React.FC<NodeViewProps> = ({ node }) => {
  const { mediaUuid, projectUuid, fileName } = node.attrs;

  return (
    <NodeViewWrapper className="my-2" contentEditable={false}>
      <ResolvedVideo projectUuid={projectUuid} mediaUuid={mediaUuid} fileName={fileName} />
    </NodeViewWrapper>
  );
};

export default VideoEmbedComponent;
